var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef } from '@angular/core';
import { ModalService } from '../../../common/services/modal.service';
import { AccountApiService } from '../../../services/account.api.service';
import { AlertifyService } from '../../../services/alertify.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions, } from '../../hub/show.info.modal/show.info.modal.provider';
import { AddEventbriteEventsModalActions, AddEventbriteEventsModalData, } from './add.eventbrite.events.modal.provider';
var AddEventbriteEvenetsModalComponent = /** @class */ (function (_super) {
    __extends(AddEventbriteEvenetsModalComponent, _super);
    function AddEventbriteEvenetsModalComponent(dialogRef, actions, imageService, alertify, accountApiService, modalService, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.accountApiService = accountApiService;
        _this.modalService = modalService;
        _this.isApproved = true;
        _this.totalEvents = 0;
        _this.totalAddressFilteredEvents = 0;
        _this.isSaving = false;
        _this.data = data;
        _this.data.events.forEach(function (x) {
            x.checked = true;
        });
        _this.totalEvents = _this.data.events.length;
        _this.totalAddressFilteredEvents = _this.data.addressFilteredEvents.length;
        return _this;
    }
    AddEventbriteEvenetsModalComponent.prototype.toggleAll = function () {
        this.data.events.forEach(function (e) {
            e.checked = !e.checked;
        });
    };
    AddEventbriteEvenetsModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    AddEventbriteEvenetsModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var events;
            return __generator(this, function (_a) {
                events = this.data.events.filter(function (x) { return x.checked; });
                if (events.length === 0) {
                    event.complete();
                    this.alertify.warning('No event selected');
                    return [2 /*return*/];
                }
                events.forEach(function (x) {
                    delete x.checked;
                });
                this.isSaving = true;
                this.accountApiService
                    .savePulledEventbriteEvents(this.data.account._id, events, this.isApproved)
                    .finally(function () {
                    event.complete();
                    _this.isSaving = false;
                })
                    .subscribe(function (result) {
                    if (result) {
                        if (result.saved.length === _this.totalEvents) {
                            _this.alertify.successfully('Save events');
                            _this.actions.confirm(event);
                            _this.close();
                        }
                        else {
                            var icons = [], text_1 = [];
                            if (result.saved.length) {
                                icons.push({ icon: 'check', color: 'green' });
                                text_1.push(result.saved.length + " events saved successfully");
                            }
                            if (result.updated.length) {
                                icons.push({ icon: 'cached', color: 'green' });
                                text_1.push(result.updated.length + " events updated");
                            }
                            if (result.merged.length) {
                                icons.push({ icon: 'list', color: 'green' });
                                text_1.push(result.merged.length + " events merged");
                            }
                            if (result.existed.length) {
                                icons.push({ icon: 'error_outline', color: 'orange' });
                                text_1.push(result.existed.length + " events not saved due to existed");
                            }
                            if (result.notSaved.length) {
                                icons.push({ icon: 'error_outline', color: 'red' });
                                text_1.push(result.notSaved.length + " events not saved due to missing properties, please check event info and address");
                            }
                            if (result.approvalStatusNotChanged.length) {
                                text_1.push("<hr style=\"width:680px;height:unset\"/>");
                                text_1.push("<span style=\"margin-bottom: 6px\">The following events already exist and " + (_this.isApproved
                                    ? '<span style="color:red">unapproved</span>'
                                    : '<span style="color:green">approved</span>') + ", they will stay " + (_this.isApproved
                                    ? '<span style="color:red">unapproved.</span>'
                                    : '<span style="color:green">approved.</span>') + "</span>");
                                result.approvalStatusNotChanged.forEach(function (x, i) {
                                    text_1.push("<span style=\"font-size: 14px\">" + (i + 1) + ": " + x + "</span>");
                                });
                            }
                            _this.modalService.show({
                                component: ShowInfoModalComponent,
                                providers: [
                                    { provide: ShowInfoModalActions, useValue: null },
                                    {
                                        provide: InfoModalData,
                                        useValue: new InfoModalData('Result', icons, text_1),
                                    },
                                ],
                                panelClass: 'width-modal-3',
                            });
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    return AddEventbriteEvenetsModalComponent;
}(BaseComponent));
export { AddEventbriteEvenetsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/add.eventbrite.events.modal/add.eventbrite.events.modal.component.ts.pre-build-optimizer.js